import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, HasProductContext, withProduct } from "@insite/client-framework/Components/ProductContext";
import { OwnProps } from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentAccountState } from "@insite/client-framework/Store/Data/Accounts/AccountsSelector";
import translate from "@insite/client-framework/Translate";
import ProductContextAvailability from "@insite/content-library/Components/ProductContextAvailability";
import { ProductCardSelections } from "@insite/content-library/Widgets/ProductList/ProductCardSelections";
import ProductListProductImage from "@insite/content-library/Widgets/ProductList/ProductListProductImage";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ProductListActions from "@tSchaedlerYesco/Overrides/Widgets/ProductList/ProductListActions";

import ProductListProductInformation from "@tSchaedlerYesco/Overrides/Widgets/ProductList/ProductListProductInformation";
import CustomApplicationState from "@tSchaedlerYesco/Store/CustomApplicationState";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState & CustomApplicationState, props: HasProductContext) => {
    return {
        account: getCurrentAccountState(state).value,
        userName: state.context.session.userName,
        guestShowProductBrandImages: state.tData.showProductImagesFlag.showProductBrandImages,
    };
};

// type Props = ProductCardSelections & HasProduct;
type Props = ReturnType<typeof mapStateToProps> & ProductCardSelections & HasProduct & HasProductContext;

export interface ProductListProductGridCardStyles {
    wrapper?: InjectableCss;
    imageWrapper?: InjectableCss;
    sponsoredText?: TypographyPresentationProps;
}

export const productGridCardStyles: ProductListProductGridCardStyles = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            overflow: hidden;
            padding-bottom: 10px;
        `,
    },
    imageWrapper: {
        css: css`
            margin: auto;
            padding: 10px 50px;
            position: relative;
        `,
    },
    sponsoredText: {
        css: css`
            font-size: 0.9em;
            opacity: 0.5;
            position: absolute;
            top: 12px;
        `,
    },
};

const styles = productGridCardStyles;

const ProductListProductGridCard: FC<Props> = ({
    product,
    showImage,
    showCompare,
    showAttributes,
    showAvailability,
    showBrand,
    showPartNumbers,
    showTitle,
    showAddToList,
    showPrice,
    showImageBadges,
    maximumNumberOfImageBadges,
    showTextBadges,
    maximumNumberOfTextBadges,
    account,
    userName,
    guestShowProductBrandImages,
}) => {
    const abc = account?.properties.showProductBrandImages;
    return (
        <StyledWrapper {...styles.wrapper} data-test-selector={`productListProductCard${product.id}`}>
            {!userName && guestShowProductBrandImages === true && (
                <StyledWrapper {...styles.imageWrapper}>
                    {product.isSponsored && <Typography {...styles.sponsoredText}>{translate("Sponsored")}</Typography>}
                    <ProductListProductImage
                        showImage={showImage}
                        showCompare={showCompare}
                        showImageBadge={showImageBadges}
                        showTextBadge={showTextBadges}
                    />
                </StyledWrapper>
            )}
            {userName && abc === "true" && (
                <StyledWrapper {...styles.imageWrapper}>
                    {product.isSponsored && <Typography {...styles.sponsoredText}>{translate("Sponsored")}</Typography>}
                    <ProductListProductImage
                        showImage={showImage}
                        showCompare={showCompare}
                        showImageBadge={showImageBadges}
                        showTextBadge={showTextBadges}
                    />
                </StyledWrapper>
            )}
            <ProductListProductInformation
                showAttributes={showAttributes}
                showAvailability={showAvailability}
                showBrand={showBrand}
                showPartNumbers={showPartNumbers}
                showTitle={showTitle}
                showImageBadges={showImageBadges}
                maxImageBadges={maximumNumberOfImageBadges}
                showTextBadges={showTextBadges}
                maxTextBadges={maximumNumberOfTextBadges}
            />
            <ProductListActions
                showAvailability={showAvailability}
                showAddToList={showAddToList}
                showPrice={showPrice}
                showBrand={showBrand}
            />

            {/* <ProductContextAvailability /> */}
        </StyledWrapper>
    );
};

export default withProduct(connect(mapStateToProps)(ProductListProductGridCard));
